/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
// --- Import hooks
import useMakeRequest from "../../../../hooks/useMakeRequest";
// Importing components
import Input from "../../../../components/UI/Input/Input";
import Button from "../../../../components/UI/Button/Button";
// Importing styles and images
import style from "./ForgotPasswordForm.module.sass";
import iconInfo from "../../../../assets/images/login/icon_information.svg";
import iconSuccess from "../../../../assets/images/login/icon_success.svg";
import iconCross from "../../../../assets/images/login/icon_cross.svg";

function ForgotPasswordForm({ setIsForgotPasswordSuccess, timer, startTimer }) {
  const [email, setEmail] = useState("");
  const [emailTouch, setEmailTouch] = useState(false);
  const [emailError, setEmailError] = useState("Invalid email");

  const [isRequested, setIsRequested] = useState(false); // if there was a request

  const [setParams, data, isLoading, hasError, error] = useMakeRequest();
  useEffect(() => {
    if (isRequested && !isLoading && !hasError && data) {
      startTimer();
      setTimeout(() => {
        setIsForgotPasswordSuccess();
      }, 2000);
    }
  }, [isRequested, isLoading, hasError, data]);

  const emailHandler = (e) => {
    // const value = event.target.value;
    setEmail(e.target.value);
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(e.target.value).toLowerCase()))
      setEmailError("Invalid email");
    else setEmailError("");
  };

  const onBlurHandler = (e) => {
    // eslint-disable-next-line default-case
    switch (e.target.name) {
      case "email":
        setEmailTouch(true);
        break;
    }
  };

  const restorePassword = (e) => {
    e.preventDefault();
    if (!emailError) {
      setIsRequested(true);
      setParams({
        c: "accountStore",
        a: "forgotPassword",
        p: { email },
      });
    }
  };

  const isShowTimer = useMemo(() => {
    return !!(+timer.min || +timer.sec);
  }, [timer]);

  const isButtonDisabled = isLoading || isShowTimer;

  return (
    <form onSubmit={restorePassword} className={style.forgotPasswordWrapper}>
      {isRequested && isLoading && (
        <div className={`${style.recoveryInProcess} ${style.userNotification}`}>
          <img src={iconInfo} alt="" />
          <span className={style.descriptionState}>
            Recovery is in process, please wait...
          </span>
        </div>
      )}
      {isRequested && !isLoading && !hasError && data && (
        <div className={`${style.success} ${style.userNotification}`}>
          <img src={iconSuccess} alt="" />
          <span className={style.descriptionState}>
            Success, check your Email!
          </span>
        </div>
      )}
      {isRequested && !isLoading && hasError && (
        <div className={`${style.notValidEmail} ${style.userNotification}`}>
          <img src={iconCross} alt="" />
          <span className={style.descriptionState}>
            {error || "Please enter valid form data!"}
          </span>
        </div>
      )}
      <Input
        type="email"
        id="email"
        placeholder="E-mail"
        value={email}
        onChange={(e) => emailHandler(e)}
        onBlur={(e) => onBlurHandler(e)}
        error={emailTouch && emailError ? emailError : null}
        className={style.emailField}
      />
      <Button
        type="submit"
        className={`btn-primary ${style.btnForgotPassword}`}
        disabled={isButtonDisabled}
      >
        restore my password
      </Button>
      {isShowTimer ? (
        <div className={style.timer}>
          An Email Has Been Sent! Resend Will Be Available In{" "}
          <span className={style.timerAccent}>
            {timer.min} Min : {timer.sec} Sec
          </span>
        </div>
      ) : (
        ""
      )}
    </form>
  );
}

export default ForgotPasswordForm;
